<template>
	<Accessible
		name="leavemodal"
		trapped
		focusFirstItem
		autoFocus
		:wait="100"
		:tabOrder="[
			{ css: '.pronto-btn.primary', clickOnEnter: true },
			{ css: '.pronto-btn.default', clickOnEnter: true },
			{ css: '.modal-close', clickOnEnter: true },
		]"
	>
		<StandardModal
			small
			open
			:title="$t('groupsettings_option_leavebubble')"
			:confirmText="$t('groupsettings_option_leavebubble')"
			@confirm="leaveGroup"
			@cancel="close"
			:confirmProps="{ loading: isLoading }"
			ref="modal"
		>
			<div class="leave-wrapper">
				<i18n-t
					keypath="groupsettings_leave_confirm_explanation"
					tag="div"
					class="leave-modal-text"
				>
					<template #GroupName>
						<strong v-text="chat.displayname" />
					</template>
				</i18n-t>
			</div>
		</StandardModal>
	</Accessible>
</template>

<script>
import { getChat } from '@/store'
import { StandardModal } from '@/components/common'
import { post } from '@/helpers/api'
import {
	redirectToLastActiveGroup,
	isGroupInRoute,
	getErrorText,
} from '@/helperMethods'
import Accessible from '@/components/common/Accessible'

export default {
	components: { StandardModal, Accessible },
	props: ['chatId'],

	data() {
		return {
			isLoading: false,
			chat: getChat(this.chatId),
		}
	},

	emits: ['close'],

	methods: {
		close() {
			this.$emit('close')
		},

		async leaveGroup() {
			this.isLoading = true
			try {
				const { data } = await post('/api/v1/bubble.leave', {
					bubble_id: this.chatId,
				})
				if (!data.ok) {
					throw new Error(this.$t(getErrorText(data.error)))
				}
				if (isGroupInRoute(this.chatId)) {
					redirectToLastActiveGroup()
				}
				this.close()
			} catch (e) {
				console.error(e)
				this.$refs.modal?.$alert.error(e)
			}
			this.isLoading = false
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.leave-wrapper {
	padding: 40px;
	text-align: center;

	.leave-modal-text {
		> strong {
			@include fontFamily(800);
		}
	}
}
</style>
